import React from 'react';
import SEO from '../../components/SEO/SEO';

import './Privacy.css';

const Privacy = () => {
    return (
        <div className="legal-page">
            <SEO
                title="Privacy Services | Digi Network"
                description="Learn more about our Privacy services to grow your business online with Digi Network."
                canonical="/privacy/privacy"
            />

            <section className="legal-hero">
                <div className="container">
                    <div className="legal-hero-content">
                        <div className="label">Legal</div>
                        <h1>Privacy Policy</h1>
                        {/* <p className="legal-updated">Last Updated: January 15, 2025</p> */}
                    </div>
                </div>
            </section>

            <section className="legal-content">
                <div className="container">
                    <div className="legal-wrapper">
                        <div className="legal-section">
                            <h2>1. Introduction</h2>
                            <p>Marketing Pro ("we," "our," or "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website or use our services.</p>
                        </div>

                        <div className="legal-section">
                            <h2>2. Information We Collect</h2>
                            <h3>Personal Information</h3>
                            <p>We may collect personal information that you voluntarily provide to us when you:</p>
                            <ul>
                                <li>Fill out a contact form or request information</li>
                                <li>Sign up for our newsletter or marketing communications</li>
                                <li>Create an account or engage our services</li>
                                <li>Participate in surveys or promotional activities</li>
                            </ul>
                            <p>This information may include your name, email address, phone number, company name, and other contact details.</p>

                            <h3>Automatically Collected Information</h3>
                            <p>When you visit our website, we automatically collect certain information about your device, including:</p>
                            <ul>
                                <li>IP address and browser type</li>
                                <li>Operating system and device information</li>
                                <li>Pages visited and time spent on pages</li>
                                <li>Referring website addresses</li>
                                <li>Cookies and similar tracking technologies</li>
                            </ul>
                        </div>

                        <div className="legal-section">
                            <h2>3. How We Use Your Information</h2>
                            <p>We use the information we collect for various purposes, including:</p>
                            <ul>
                                <li>Providing and maintaining our services</li>
                                <li>Responding to your inquiries and requests</li>
                                <li>Sending marketing communications (with your consent)</li>
                                <li>Improving our website and services</li>
                                <li>Analyzing usage patterns and trends</li>
                                <li>Preventing fraud and ensuring security</li>
                                <li>Complying with legal obligations</li>
                            </ul>
                        </div>

                        <div className="legal-section">
                            <h2>4. Information Sharing and Disclosure</h2>
                            <p>We may share your information in the following situations:</p>
                            <ul>
                                <li><strong>Service Providers:</strong> We may share information with third-party vendors who perform services on our behalf</li>
                                <li><strong>Business Transfers:</strong> If we're involved in a merger, acquisition, or sale of assets</li>
                                <li><strong>Legal Requirements:</strong> When required by law or to protect our rights</li>
                                <li><strong>With Your Consent:</strong> We may share information with your explicit permission</li>
                            </ul>
                            <p>We do not sell, rent, or trade your personal information to third parties for marketing purposes.</p>
                        </div>

                        <div className="legal-section">
                            <h2>5. Cookies and Tracking Technologies</h2>
                            <p>We use cookies and similar tracking technologies to enhance your experience on our website. You can control cookie settings through your browser, but disabling cookies may affect website functionality.</p>
                            <p>Types of cookies we use:</p>
                            <ul>
                                <li><strong>Essential Cookies:</strong> Required for website operation</li>
                                <li><strong>Analytics Cookies:</strong> Help us understand how visitors use our site</li>
                                <li><strong>Marketing Cookies:</strong> Used to deliver relevant advertisements</li>
                            </ul>
                        </div>

                        <div className="legal-section">
                            <h2>6. Data Security</h2>
                            <p>We implement appropriate technical and organizational measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the internet is 100% secure.</p>
                        </div>

                        <div className="legal-section">
                            <h2>7. Your Rights and Choices</h2>
                            <p>Depending on your location, you may have certain rights regarding your personal information:</p>
                            <ul>
                                <li><strong>Access:</strong> Request access to your personal information</li>
                                <li><strong>Correction:</strong> Request correction of inaccurate information</li>
                                <li><strong>Deletion:</strong> Request deletion of your personal information</li>
                                <li><strong>Opt-Out:</strong> Unsubscribe from marketing communications</li>
                                <li><strong>Data Portability:</strong> Request a copy of your data in a portable format</li>
                            </ul>
                            <p>To exercise these rights, please contact us at ali@diginetworkads.com</p>
                        </div>

                        <div className="legal-section">
                            <h2>8. Third-Party Links</h2>
                            <p>Our website may contain links to third-party websites. We are not responsible for the privacy practices of these external sites. We encourage you to review their privacy policies.</p>
                        </div>

                        <div className="legal-section">
                            <h2>9. Children's Privacy</h2>
                            <p>Our services are not intended for individuals under the age of 18. We do not knowingly collect personal information from children. If you believe we have collected information from a child, please contact us immediately.</p>
                        </div>

                        <div className="legal-section">
                            <h2>10. International Data Transfers</h2>
                            <p>Your information may be transferred to and processed in countries other than your own. We ensure appropriate safeguards are in place for such transfers in accordance with applicable laws.</p>
                        </div>

                        <div className="legal-section">
                            <h2>11. Changes to This Privacy Policy</h2>
                            <p>We may update this Privacy Policy from time to time. We will notify you of significant changes by posting the new policy on this page and updating the "Last Updated" date.</p>
                        </div>

                        <div className="legal-section">
                            <h2>12. Contact Us</h2>
                            <p>If you have questions or concerns about this Privacy Policy or our data practices, please contact us:</p>
                            <div className="contact-info-legal">
                                <p><strong>Email:</strong> ali@diginetworkads.com</p>
                                <p><strong>Phone:</strong> +92 300 4817173</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Privacy;
